module.exports = __webpack_public_path__ + "static/media/3.fd6b722e.svg";